<template>
    <v-toolbar  class="pink darken-2" dark>
        <v-btn icon :to="{name: 'Accueil'}">
            <v-icon>search</v-icon>
        </v-btn>
        <v-toolbar-title v-if="currentSen">{{currentSen.qualite}} {{currentSen.nomUsuel}} {{currentSen.prenomUsuel}}</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-side-icon @click.stop="$parent.drawerRight = !$parent.drawerRight"></v-toolbar-side-icon>
    </v-toolbar>
</template>
<script>
  import {mixin} from "./Senateur.mixin";

  export default {
    mixins: [mixin]
  };
</script>
<style>

</style>


// WEBPACK FOOTER //
// SenateurToolbar.vue?1e2417a7